module.exports = __webpack_public_path__ + "static/media/Asset 1_6.b6dc83c4.png";